const juniorBase = "/junior";

export const JuniorRoutes = {
    ROOT: juniorBase,

    // Overview of family members
    OVERVIEW: `${juniorBase}/overview`,

    // Detail of a family member
    DETAIL: `${juniorBase}/detail`,

    // Activate George Junior
    ACTIVATE_TOUR: `${juniorBase}/activate/tour`,

    // Contact screen for George Junior activation
    ACTIVATE_CONTACT: `${juniorBase}/activate/contact`,

    // Documents screen for George Junior activation
    ACTIVATE_DOCUMENTS: `${juniorBase}/activate/documents`,

    // Signing for George Junior activation
    ACTIVATE_SIGNING: `${juniorBase}/activate/signing`,

    // Result screen after Junior activate process – success
    ACTIVATE_SUCCESS: `${juniorBase}/activate/success`,

    // Result screen after Junior activate process – error
    ACTIVATE_ERROR: `${juniorBase}/activate/error`,

    // Download George Junior app screen
    ACTIVATION_DOWNLOAD_APP: `${juniorBase}/activation/download-app`,

    // Activate George app on child device (instructions)
    ACTIVATION_ACTIVATE_APP: `${juniorBase}/activation/activate-app`,

    // Activation George Junior user screen
    ACTIVATION_ACTIVATE_USER: `${juniorBase}/activation/activate-user`,

    // Scan QR code to Download George app
    ACTIVATION_CODE: `${juniorBase}/activation/code`,

    // Result screen after Junior activation process – success
    ACTIVATION_SUCCESS: `${juniorBase}/activation/success`,

    // Result screen after Junior activation process – error
    ACTIVATION_ERROR: `${juniorBase}/activation/error`,

    // PDF viewer for documents
    PDF: `${juniorBase}/pdf`,
};



// WEBPACK FOOTER //
// ./src/components/gJunior/JuniorRoutes.ts